import React from 'react';
import {FieldError} from 'react-hook-form';
import classnames from 'classnames';
import {getErrorMessage} from 'helpers/utils';

interface TextAreaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: FieldError | FieldError[];
  className?: string;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
  const {id, className, label, error, onChange, required, ...inputProps} = props;
  const errorMessage = error ? getErrorMessage(error, label) : null;

  return (
    <div className="textarea-container">
      {label && (
        <label htmlFor={id}>
          {label} {required && <span>*</span>}
        </label>
      )}
      <textarea
        id={id}
        ref={ref}
        onChange={onChange}
        className={classnames(className && error ? 'textarea--error' : 'textarea', className)}
        {...inputProps}
      />
      {errorMessage && <p className="input-error-message">{errorMessage}</p>}
    </div>
  );
});
